const config = {
    // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
    basename: '/',
    defaultPath: '/dashboard/default',
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 12,
    app_version: "1.0.0",
    fe_URL: process.env.REACT_APP_FE_URL || "secure-share.emapta.com",
    serviceUrl: process.env.REACT_APP_SERVICE_URL || "https://secureshare-be.emapta.com/"
};

export default config;
